import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../services/general/toast.service';

@Component({
  selector: 'app-modal-split-question',
  templateUrl: './modal-split-question.component.html',
  styleUrls: ['./modal-split-question.component.scss'],
  standalone: false
})
export class ModalSplitQuestionComponent implements OnInit {
  originalQuestion: any;
  newQuestions: any[] = [];
  questionIdCounter = 1;

  constructor(
    public dialogRef: MatDialogRef<ModalSplitQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService,
    private toast: ToastService
  ) {
    this.originalQuestion = data.question;
  }

  ngOnInit(): void {
    if (this.originalQuestion?.customs?.split_questions) {
      this.newQuestions = this.originalQuestion.customs.split_questions;
      this.questionIdCounter = this.newQuestions.length + 1;
      return;
    }
    this.addSplit();
    this.addSplit();

    // Pre-fill the splits with the statements produced by the AI rewriting
    // pipeline, one statement per split.
    const statements: string[] = Array.isArray(this.data?.statements) ? this.data.statements : [];
    if (statements.length > 0) {
      this.prefillSplits(statements);
    } else if (this.data?.rewritten_statement) {
      this.newQuestions[0].question = this.data.rewritten_statement;
    }
  }

  private prefillSplits(statements: string[]): void {
    // Ensure there are enough split slots for every returned statement.
    while (this.newQuestions.length < statements.length) {
      this.addSplit();
    }
    statements.forEach((statement, i) => {
      this.newQuestions[i].question = statement;
    });
  }

  addSplit(prefillText?: string): void {
    // Clone completo dell'originale (eredita tutto cio' che il backend
    // potrebbe aspettarsi). question_history_id viene azzerato: uno split
    // genera domande nuove, non la stessa storia dell'originale.
    const clone = JSON.parse(JSON.stringify(this.originalQuestion));
    clone.id = this.questionIdCounter++;
    clone.question = prefillText ?? '';
    clone.is_new = true;
    clone.question_history_id = null;
    clone.response = {customs: {}, attachments: []};
    this.newQuestions.push(clone);
  }

  removeSplit(index: number): void {
    if (this.newQuestions.length > 2) {
      this.newQuestions.splice(index, 1);
    }
  }

  save() {
    // Basic validation
    if (this.newQuestions.some(q => !q.question)) {
      this.toast.error(
        this.translateService.instant('generic.error'),
        this.translateService.instant('modals.modal-survey-details.errors.title-is-required')
      );
      return;
    }

    this.dialogRef.close(this.newQuestions);
  }

  close() {
    this.dialogRef.close();
  }
}
